/* ==========================================================================
   POLYMERCRAFTS — FAQ PDP ACCORDION JS CONTROLLER
   File: assets/faq-pdp.js
   Description: Manages smooth accordion expand/collapse toggles, 
   aria attributes, and Theme Editor live load events.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initFaqAccordions();
});

// Shopify Theme Editor Section Load Event Support
document.addEventListener('shopify:section:load', function (event) {
  initFaqAccordions(event.target);
});

function initFaqAccordions(scope = document) {
  const faqSections = scope.querySelectorAll('.sec__pc-faq-pdp');

  faqSections.forEach((section) => {
    const accordion = section.querySelector('.pc-accordion');
    if (!accordion) return;

    const items = accordion.querySelectorAll('.pc-accordion-item');

    items.forEach((item) => {
      const header = item.querySelector('.pc-accordion-header');
      const content = item.querySelector('.pc-accordion-content');

      if (!header || !content) return;

      // Click event handler
      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Close other items if allow_multiple_open is false
        const allowMultiple = section.dataset.allowMultiple === 'true';
        if (!allowMultiple && !isOpen) {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains('is-open')) {
              otherItem.classList.remove('is-open');
              const otherHeader = otherItem.querySelector('.pc-accordion-header');
              const otherContent = otherItem.querySelector('.pc-accordion-content');
              if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
              if (otherContent) otherContent.style.display = 'none';
            }
          });
        }

        // Toggle current item
        if (isOpen) {
          item.classList.remove('is-open');
          header.setAttribute('aria-expanded', 'false');
          content.style.display = 'none';
        } else {
          item.classList.add('is-open');
          header.setAttribute('aria-expanded', 'true');
          content.style.display = 'block';
        }
      });
    });
  });
}
